import { useMemo } from 'react';
import Raven from 'raven-js';
import { registerQuery, useQuery } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { chirpClient } from '../http/chirpClient';
import { fetchRpc } from '../../__generated__/chirp/com/hubspot/connected/application/status/rpc/frontend/ConnectedStatusGraphQLService';
export const GET_APP_STATUS = registerQuery({
  fieldName: 'connectedAppStatus',
  args: ['appId', 'categories'],
  fetcher: request => {
    return chirpClient.call(fetchRpc, {
      request: {
        locale: getLang(),
        statusFetchOptions: {
          appIds: [request.appId],
          categories: request.categories
        }
      }
    });
  }
});
export const useGetAppStatuses = ({
  appId,
  categories
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_APP_STATUS, {
    variables: {
      appId: appId,
      categories
    },
    skip: !appId,
    onError: err => {
      Raven.captureException(err, {
        extra: {
          appId
        }
      });
    }
  });
  const filteredStatuses = useMemo(() => {
    var _data$connectedAppSta;
    return ((data === null || data === void 0 || (_data$connectedAppSta = data.connectedAppStatus) === null || _data$connectedAppSta === void 0 ? void 0 : _data$connectedAppSta.results) || []).filter(status => status.type !== AppConnectionStatuses.NO_STATUS_AVAILABLE);
  }, [data]);
  return {
    data: filteredStatuses,
    loading,
    error,
    refetch
  };
};